import { HALApiService } from './../hal-api.service'
import { createItemsData } from './../../helpers/request-helpers'
import { CachedService } from './base-service'
import entities from '../../../../config/Entities'

export const helpSectionsService = new CachedService(entities.Orderadmin_Help_Entity_Section, '/help/section', HALApiService, createItemsData)
